import { useSyncExternalStore } from "react";

/** The sync status the top bars show: whether a run is in progress, how many sales are
 * unsynced, and the last run's message. The offline queue (plan Phase 7) drives it through
 * `setSyncState`; `syncNow` is replaced by the real replayer when the queue is registered. */
export type SyncState = { syncing: boolean; pending: number; failed: number; message: string | null };

let state: SyncState = { syncing: false, pending: 0, failed: 0, message: null };
const listeners = new Set<() => void>();

export function setSyncState(patch: Partial<SyncState>): void {
  state = { ...state, ...patch };
  listeners.forEach((l) => l());
}
export const getSyncState = (): SyncState => state;
export const useSyncState = (): SyncState =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getSyncState,
    getSyncState,
  );

type Runner = () => Promise<void>;
let runner: Runner = async () => undefined;
export function registerSyncRunner(r: Runner): void {
  runner = r;
}
/** Sync now: single-flight; a click during a run is ignored. */
export async function syncNow(): Promise<void> {
  if (state.syncing) return;
  setSyncState({ syncing: true, message: null });
  try {
    await runner();
  } finally {
    setSyncState({ syncing: false });
  }
}
